import { SearchPluginProps } from '@react-pdf-viewer/search';

import styles from './PDFViewer.module.scss';

export const searchPluginProps: SearchPluginProps = {
    onHighlightKeyword: (props) => {
        props.highlightEle.style.backgroundColor = styles.previewHighlightBackground;
    },
};
